/* unplugin-vue-components disabled */import script from "./patientInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./patientInfo.vue?vue&type=script&lang=ts&setup=true"

import "./patientInfo.vue?vue&type=style&index=0&id=1c6ffbdb&lang=less&scoped=true"

import exportComponent from "/data/liulv-h5/quantum-technology/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c6ffbdb"]])

export default __exports__